export const currentSellerId = "currentSellerId";
export const notificationsLastUpdate = "notificationsLastUpdate";
export const lastNotificationUpdated = "lastNotificationUpdated";